import {Injectable} from '@angular/core';


declare var $: any;
declare var jQuery: any;

@Injectable()
export class UiStateService {

    public individualGoal = 5000;
    public teamGoal = 25000;
    public campaign = null;     // Null = no specific campaign set - defaults to LLS generic branding

    //TODO: why wouldn't these be merged with what's in event.service.ts?
    public campaignTexts = {
        'program-se': 'Your fundraising efforts for Blood Cancer United, formerly LLS, support the most pioneering research of our time, ' +
                        'patient education, support and access to the therapies that blood cancer patients need.' +
                        ' You’ll be part of a growing team of passionate, caring people determined to do more for more people with blood cancer.',
        'program-dd': 'Your fundraising efforts for for Blood Cancer United, formerly LLS, support the most pioneering research of our time, ' +
                        'patient education, support and access to the therapies that blood cancer patients need.' +
                        ' You’ll be part of a growing team of passionate, caring people determined to do more for more people with blood cancer.',
        'program-ltn': 'Blood Cancer United’s Light The Night brings light to the darkness of cancer. ' +
                        'The light and warmth we generate delivers hope in time of despair, community in place of loneliness and ' +
                        'life-saving RESEARCH & SUPPORT for cancer patients and their families. Each year, friends, families and ' +
                        'co-workers gather together to celebrate, honor & remember those touched by cancer.',
        'program-tnt': 'Team In Training is more than an event—it’s your chance to push your limits and create real impact. ' +
                        'By joining, you’ll train for an unforgettable experience alongside a community of teammates who share your ' +
                        'passion for helping others. <br/><br/>' +
                        'Every mile and every effort fuels lifesaving research, patient support, and progress toward cures. ' +
                        'And when you rally your friends and family, you multiply that impact—because every gift, big or small, ' +
                        'brings hope to patients and families facing blood cancer. <br/><br/>' +
                        'Explore our fundraising resources for tips and strategies to help you build a meaningful campaign ' +
                        'that turns your passion into impact. ',
        'program-mwoy': 'Blood Cancer United’s Man & Woman of the Year campaign brings together' +
                        ' influential and compassionate leaders in the community to raise critical funds' +
                        ' for blood cancer research, advocacy and patient care. Each year candidates form' +
                        ' teams made up of friends, family and colleagues to compete in their local community' +
                        ' for the title of Man or Woman of the Year.',
        'program-voy': 'Blood Cancer United’s Visionaries of the Year campaign brings together' +
                        ' influential and compassionate leaders in the community to raise critical funds' +
                        ' for blood cancer research, advocacy and patient care. Each year candidates form' +
                        ' teams made up of friends, family and colleagues to compete in their local community' +
                        ' for the title of Visionary of the Year.',
        'program-soy': 'Students of the Year is a philanthropic leadership development program for exemplary high' +
                        ' school students. Each year candidates form teams made up of friends, family and colleagues' +
                        ' to compete in their local community for the title of Students of the Year',
        'program-svoy': `Every year, courageous young leaders embark on an exciting 7-week fundraising journey with a` +
                        ` united goal to create a world without blood cancers, striving to earn Blood Cancer United's` +
                        ` Student Visionary of the Year title.`,
        'program-regatta': 'The Leukemia & Lymphoma Society’s (LLS) Leukemia Cup Regatta is a thrilling series of ' +
                        'sailing events that combines the joy of recreational boating with fundraising' +
                        ' dedicated to helping LLS find cures and ensure access to treatment for blood cancer patients.',
        'program-s2': 'Hero Squad is a set of science-based philanthropy programs. We connect schools with local' +
                        ' blood cancer patients, provide tangible life skills to participants, and allow' +
                        ' students to see the impact they’re making in the lives of others.'
    };

    constructor() {}

    setCampaign(newCampaign:any) {
        var oldCampaign = this.campaign;
        this.campaign = newCampaign;
        if (oldCampaign != null) $('body').removeClass(oldCampaign.id);
        if (this.campaign != null) $('body').addClass(this.campaign.id);
    }

    changeParticipantLabel(cssClass: string) {
        if (cssClass === 'program-mwoy' || cssClass === 'program-soy' || cssClass === 'program-voy' || cssClass === 'program-svoy') {
            return 'Candidate';
        } else if (cssClass === 'program-s2') {
            return 'Student';
        } else {
            return 'Participant';
        }
    }

    changeTeamLabel(cssClass: string) {
        if (cssClass === 'program-s2') {
            return 'Class';
        } else {
            return 'Team';
        }
    }

    showUpdatePassword(pwToken: string) {
        if (pwToken != null) {
            $('body').addClass('up');
        }
    }
}
